import React, { useState, useEffect } from "react";
import { API } from "../backend";
import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useFlutterwave } from "flutterwave-react-v3";
// import Footer from "../../Component/Footer";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
// import Logo from '../../images/logo.png'
import ProceedModal from "../../Component/ProceedModal"; // will need to be changed to account for school ID i think
import { styled } from "@mui/system";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import Layout from "../../reusables/layout/layout";
import LatePaymentFormCASBece from "../../Component/latepaymentform/latepayment_cas_bece";

const CustomTextField = styled(TextField)({
  // "& .MuiInputBase-input.Mui-disabled": {
  //     color: "red !important",
  //     "-webkit-text-fill-color": "red !important",
  //     borderColor: "red !important"
  //   },
  //   "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
  //     borderColor: "red !important"
  //   }
  "& .MuiInputBase-input.Mui-disabled": {
    color: "rgba(0,0,0,0.6) !important",
    "-webkit-text-fill-color": "rgba(0,0,0,0.6) !important",
    borderColor: "rgba(0,0,0,0.6) !important",
  },
  //   "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
  //     borderColor: "rgba(0,0,0,0.38) !important"
  //   }
});

const LatePaymentFormJss = () => {
  return (
    <Layout>
      <LatePaymentFormCASBece examName='CAS/Placement ' examType='CAS/Placement Examination' lateRegistrationType="CAS Late Registration" />
    </Layout>
  );
};

export default LatePaymentFormJss;

// const [school, setSchool] = useState('')
// const [schoolId, setSchoolId] = useState('')
// const [schoolType, setSchoolType] = useState('')
// const [localGovt, setLocalGovt] = useState('')
// const [closing, setClosing] = useState('')
// const [name, setName] = useState('')
// const [email, setEmail] = useState('')
// const [phone, setPhone] = useState('')
// const [address, setAddress] = useState('')
// const [mda, setMda] = useState('')
// const [pinNum, setPinNum] = useState()
// const [totalPrice, setTotalPrice] = useState('')
// const [genInfo, setGenInfo] = useState([])
// const [lgaId, setLgaId] = useState('')
// const [schoolTypeId, setSchoolTypeId] = useState('')
// const [open, setOpen] = useState(false);
// const [location, setLocation] = useState('')
// // const [user, setUser] = useState({});

// const [casToken, setCasToken] = useState("");

// const user = useSelector(state => state.user.data)

// useEffect(() => {
//   // const schlType = localStorage.getItem("schoolType")
//   // const schId = localStorage.getItem("schoolId")
//   // const lgaName = localStorage.getItem("LgaName")
//   // const schTypeId = localStorage.getItem("schoolTypeId")
//   // const lgId = localStorage.getItem("LgaId")
//   // const payemail = localStorage.getItem("payeremail")
//   // const date = localStorage.getItem("closingDate")
//   // const schName = localStorage.getItem("schoolName")
//   // const payname = localStorage.getItem("PayerName")
//   // const payphone = localStorage.getItem("Payerphone")

//   const userId = localStorage.getItem("casId");

//   //getting the id from the localstorage
//   const token = localStorage.getItem("castoken");
//   setCasToken(token);
//   const casData = async () => {
//     const response = await axios.get(`${API}auth/cas/user/`, {
//       headers: { Authorization: `Bearer ${token}` },
//     });

//     // setAuth(response?.data?.response?.user);
//     setUser(response?.data?.response?.user);
//     console.log(user)
//     // setDbName(response?.data?.response?.user?.contactPerson);
//     // setDbEmail(response?.data?.response?.user?.email);
//     // setDbPhone(response?.data?.response?.user?.phoneNumber);
//     // setDbLasra(response?.data?.response?.user?.lasra);
//   };

//   casData();
//   // set the states
//   // setSchoolType(schlType ? schlType : '')
//   // setSchoolId(schId ? schId : '')
//   // setLocalGovt(lgaName ? lgaName : '')
//   // setSchoolTypeId(schTypeId ? schTypeId : '')
//   // setLgaId(lgId ? lgId : '')
//   // setEmail(payemail ? payemail : '')
//   // setClosing(date ? date : '')
//   // setSchool(schName ? schName : '')
//   // setPhone(payphone ? payphone : '')
//   // setName(payname ? payname : '')

// }, [])
